export const visit = (vm, at) => {
at({ "en": { "durations": { "minute": "{{ count }} min", "hour": "{{ count }} hr", "combined": "{{ hourText }} {{ minuteText }}", "placeholderName": "{{ durations }} meeting" } } });
};